/**
 * 我采购的招标列表地址
 */
export const TENDER_AUCTION_PURCHASE_LIST_PAGE_PATH =
  '/auction/tender/list/purchase'
